import { Component, inject } from '@angular/core';
import { faFacebookF, faLinkedinIn, faTiktok, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Router, RouterLink } from '@angular/router';
@Component({
  selector: 'app-footer',
  imports: [FontAwesomeModule, RouterLink],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  currentYear = new Date().getFullYear();
  faFacebookF = faFacebookF;
  faLinkedinIn = faLinkedinIn;
  faTiktok = faTiktok;
  faInstagram = faInstagram;
  faWhatsapp = faWhatsapp;

  private router = inject(Router);
  categories = ['Cap', 'T-Shirt', 'Bottle', 'Mug', 'Resin Keychain'];

  goToCategory(name: string) {
    this.router.navigate(['/products'], {
      queryParams: { category: name }
    });
  }
}
